import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

import { Injectable, inject } from '@angular/core';
import { Workspace } from './models/core.models'; // Assuming Workspace is a model like Feed
import { UserWorkspacesService } from './services/user-workspaces.service';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceResolver implements Resolve<Workspace | null> {
  private readonly userWorkspaces = inject(UserWorkspacesService);

  resolve(route: ActivatedRouteSnapshot): Observable<Workspace | null> {
    const workspaceId = route.paramMap.get('workspaceId');
    if (!workspaceId) {
      return of(null); // or throw an error, or navigate away
    }

    return this.userWorkspaces.workspaceById$(workspaceId);
  }
}
